module.exports = __webpack_public_path__ + "static/media/coach_sample_csv.e89f9a2e.csv";